import { useState, useCallback } from "react";

export default function useTableHover() {
  const [hoverRow, setHoverRow] = useState(null);
  const [hoverCol, setHoverCol] = useState(null);

  const clear = useCallback(() => {
    setHoverRow(null);
    setHoverCol(null);
  }, []);

  const bindCell = useCallback(
    (rowIndex, colIndex) => ({
      onMouseEnter: () => {
        setHoverRow(rowIndex);
        setHoverCol(colIndex);
      },
      onMouseLeave: clear,
    }),
    [clear],
  );

  return { hoverRow, hoverCol, bindCell };
}
